// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

/*
    Contains constants for the z-index values of elements that are part of the global stack context.
    In other words, z-index values that are "inside" a component are not added here.
    This prevents conflicts between identical z-index values in different components.
*/

/* Toolbox z-index: 40; set in scratch-blocks */

/* tooltips should go over add buttons if they overlap */

/* monitors go over add buttons */

/* "ask" block text input goes above monitors */

/* behind menu-bar */

/* Block drag z-index: 1000; default 50 is overriden in blocks.css */

/* so it is draggable into other panes */

/* behind modals */

/* behind modals */

/* in most interfaces, the context menu is always on top */

.context-menu_context-menu_MCivL {
    min-width: 130px;
    padding: 5px 0; /* The white strip at the top and bottom of the menu */
    margin: 2px 0 0; /* To keep the menu below the cursor comfortably */
    font-size: 0.85rem;
    text-align: left;
    background-color: var(--ui-white);
    border: 1px solid var(--ui-black-transparent);
    border-radius: calc(0.5rem / 2);
    box-shadow: 0px 0px 5px 1px var(--shadow);
    pointer-events: none;
    transition: opacity 0.2s ease;
    z-index: 10000;
}

.context-menu_menu-item__0lIk {
    padding: 8px 12px;
    white-space: nowrap;
    cursor: pointer;
    transition: 0.1s ease;
}

.context-menu_menu-item__0lIk:hover {
    background: var(--looks-secondary);
    color: white;
}

.context-menu_menu-item-bordered_lrdQw {
    border-top: 1px solid var(--ui-black-transparent);
}

.context-menu_menu-item-danger_ssCE7:hover {
    background: var(--error-primary);
}
`, "",{"version":3,"sources":["webpack://./src/components/context-menu/context-menu.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;sDACsD;;AAEtD,+CAA+C;;AAE/C;;;;CAIC;;AAED,+CAA+C;;AAE/C,wDAAwD;;AAExD,iCAAiC;;AAEjC,+CAA+C;;AAE/C,oBAAoB;;AAEpB,oEAAoE;;AAEpE,wCAAwC;;AAExC,kBAAkB;;AAElB,kBAAkB;;AAElB,0DAA0D;;AAE1D;IACI,gBAAgB;IAChB,cAAc,EAAE,sDAAsD;IACtE,eAAe,EAAE,kDAAkD;IACnE,kBAAkB;IAClB,gBAAgB;IAChB,iCAAiC;IACjC,6CAA6C;IAC7C,+BAA+B;IAC/B,yCAAyC;IACzC,oBAAoB;IACpB,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,kCAAkC;IAClC,YAAY;AAChB;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,gCAAgC;AACpC","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n/*\n    Contains constants for the z-index values of elements that are part of the global stack context.\n    In other words, z-index values that are \"inside\" a component are not added here.\n    This prevents conflicts between identical z-index values in different components.\n*/\n\n/* Toolbox z-index: 40; set in scratch-blocks */\n\n/* tooltips should go over add buttons if they overlap */\n\n/* monitors go over add buttons */\n\n/* \"ask\" block text input goes above monitors */\n\n/* behind menu-bar */\n\n/* Block drag z-index: 1000; default 50 is overriden in blocks.css */\n\n/* so it is draggable into other panes */\n\n/* behind modals */\n\n/* behind modals */\n\n/* in most interfaces, the context menu is always on top */\n\n.context-menu {\n    min-width: 130px;\n    padding: 5px 0; /* The white strip at the top and bottom of the menu */\n    margin: 2px 0 0; /* To keep the menu below the cursor comfortably */\n    font-size: 0.85rem;\n    text-align: left;\n    background-color: var(--ui-white);\n    border: 1px solid var(--ui-black-transparent);\n    border-radius: calc(0.5rem / 2);\n    box-shadow: 0px 0px 5px 1px var(--shadow);\n    pointer-events: none;\n    transition: opacity 0.2s ease;\n    z-index: 10000;\n}\n\n.menu-item {\n    padding: 8px 12px;\n    white-space: nowrap;\n    cursor: pointer;\n    transition: 0.1s ease;\n}\n\n.menu-item:hover {\n    background: var(--looks-secondary);\n    color: white;\n}\n\n.menu-item-bordered {\n    border-top: 1px solid var(--ui-black-transparent);\n}\n\n.menu-item-danger:hover {\n    background: var(--error-primary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"context-menu": `context-menu_context-menu_MCivL`,
	"contextMenu": `context-menu_context-menu_MCivL`,
	"menu-item": `context-menu_menu-item__0lIk`,
	"menuItem": `context-menu_menu-item__0lIk`,
	"menu-item-bordered": `context-menu_menu-item-bordered_lrdQw`,
	"menuItemBordered": `context-menu_menu-item-bordered_lrdQw`,
	"menu-item-danger": `context-menu_menu-item-danger_ssCE7`,
	"menuItemDanger": `context-menu_menu-item-danger_ssCE7`
};
export default ___CSS_LOADER_EXPORT___;
